import React from "react";
import { Box, Button, Typography } from "@mui/material";
import StarIcon from "@mui/icons-material/Star";
import PlayArrowIcon from "@mui/icons-material/PlayArrow";
import { useNavigate } from "react-router-dom";

const HeroSection = ({mainImage}) => {
  const navigate = useNavigate()
  return (
    <>
      <style>{`
        .hero-wrapper {
          width: 100%;
          display: flex;
          justify-content: center;
          padding: 40px 0;
        }

        .hero-container {
          width: 90%;
          max-width: 1400px;
          background-image: url("https://html.themehour.net/kleanix/demo/assets/img/hero/hero_bg_3_1.jpg");
          background-size: cover;
          background-position: center;
          border-radius: 40px;
          border: 4px solid #000;
          padding: 70px 80px;
          position: relative;
          overflow: hidden; /* needed for rounded corners */
          display: flex;
          align-items: center;
          height: 580px;
        }

        /* LEFT */
        .hero-left {
          flex: 0 0 52%;
          position: relative;
          z-index: 10;
        }

        .hero-title {
          font-size: 64px;
          font-weight: 900;
          line-height: 1.05;
        }

        .green-text { color: #7ac142; }

        .hero-subtext {
          margin-top: 22px;
          font-size: 18px;
          max-width: 520px;
          color: #666;
        }

        .cta-section {
          display: flex;
          align-items: center;
          gap: 25px;
          margin-top: 35px;
        }

        .discover-btn {
          background: #7ac142 !important;
          padding: 14px 34px !important;
          border-radius: 40px !important;
          font-weight: 700 !important;
          font-size: 16px !important;
          color: #fff !important;
        }
        .discover-btn-services {
          background: #ffc400 !important;
          padding: 14px 34px !important;
          border-radius: 40px !important;
          font-weight: 700 !important;
          font-size: 16px !important;
          color: black !important;
        }

        .play-section {
          display: flex;
          align-items: center;
          gap: 10px;
        }

        .play-circle {
          width: 60px;
          height: 60px;
          background: #ffc400;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          box-shadow: 0 6px 20px rgba(255,200,0,0.4);
        }

        .rating-box {
          margin-top: 55px;
          display: flex;
          align-items: center;
          gap: 24px;
        }

        .avatars img {
          width: 42px;
          height: 42px;
          border-radius: 50%;
          border: 3px solid #fff;
          margin-left: -10px;
        }

        /* RIGHT */
        .hero-right {
          flex: 0 0 48%;
          position: relative;
          height: 100%;
          z-index: 5;
        }

        .right-green-bg {
          position: absolute;
          height: 130%;
          right: -80px;
          bottom: -70px;
          z-index: 2;
          pointer-events: none;
        }

        .right-yellow-bg {
          position: absolute;
          height: 132%;
          right: -35px;
          bottom: -70px;
          z-index: 1;
          pointer-events: none;
        }

        /* ✅ DESKTOP FIX: keep man inside the clipped container */
        .main-man {
          position: absolute;
          height: 135%;        /* was 135% */
          right: -10px;         /* was -10px */
          bottom: -180px;         /* was -80px */
          z-index: 3;
        
        
        }

        /* FLOATING SHAPES */
        .float-star-left {
          width: 90px;
          position: absolute;
          top: 15px;
          left: -2px;
          animation: float 3s ease-in-out infinite;
          z-index: 15;
        }

        .float-star-right {
          width: 50px;
          position: absolute;
          top: 70px;
          right: 120px;
          animation: float2 3s ease-in-out infinite;
          z-index: 15;
        }

        .yellow-arrow {
          width: 190px;
          position: absolute;
          left: 50%;
          bottom: 110px;
          z-index: 5;
        }

        @keyframes float {
          0%,100% { transform: translateY(0); }
          50% { transform: translateY(-10px); }
        }

        @keyframes float2 {
          0%,100% { transform: translateY(0); }
          50% { transform: translateY(12px); }
        }

        /* ✅ If you want the man a bit bigger on large desktop without clipping */
        @media (min-width: 1200px) {
          .main-man {
            height: 108%;
            bottom: -80px;
            right: 0px;
          }
          
        }

        /* ================= MOBILE RESPONSIVE ================= */
        @media (max-width: 960px) {
          .hero-container {
            flex-direction: column;
            padding: 40px 24px 50px;
            height: auto;
            gap: 22px;
          }

          .hero-left,
          .hero-right {
            width: 100%;
            flex: 0 0 100%;
          }

          .hero-right {
            margin-top: 40px;
            height: 340px;
            position: relative;
            overflow: hidden;
          }

          .hero-title { font-size: 42px; }

          .float-star-left {
            left: auto;
            right: 16px;
            top: 16px;
            width: 60px;
          }

          .float-star-right {
            right: 40px;
            top: 120px;
            width: 42px;
          }

          .yellow-arrow { display: none; }

          /* center shapes on mobile */
          .right-green-bg,
          .right-yellow-bg {
            left: 50%;
            right: auto;
            transform: translateX(-50%);
            bottom: -30px;
          }

          /* keep man visible on mobile too */
          .main-man {
            height: 100%;
            bottom: 0;
            right: 50%;
            transform: translateX(55%);
          }
        }

        @media (max-width: 600px) {
          .hero-title {
            font-size: 34px;
            line-height: 1.15;
          }

          .hero-subtext { font-size: 15px; }

          .cta-section {
            flex-direction: column;
            align-items: flex-start;
            gap: 16px;
          }

          .rating-box {
            flex-wrap: wrap;
            gap: 14px;
          }

          .hero-right { height: 280px; }

          .main-man {
            transform: translateX(52%);
          }
        }
      `}</style>

      <Box className="hero-wrapper">
        <Box className="hero-container">
          {/* FLOATING SHAPES */}
          <img
            src="https://html.themehour.net/kleanix/demo/assets/img/shape/home-3-shape-1.svg"
            className="float-star-left"
            alt=""
          />
          <img
            src="https://html.themehour.net/kleanix/demo/assets/img/shape/servicce-2-shape-theme2.svg"
            className="float-star-right"
            alt=""
          />
          <img
            src="https://html.themehour.net/kleanix/demo/assets/img/shape/home-3-shape-3.svg"
            className="yellow-arrow"
            alt=""
          />

          {/* LEFT */}
          <Box className="hero-left">
            <Typography className="hero-title">
              Complete Home Care for <span className="green-text">Bloomington.</span>
              <br />
              One Team, One Membership.
            </Typography>

            <Typography className="hero-subtext">
             From emergency water mitigation to seasonal HVAC tune-ups and professional cleaning—Rite Home Pros handles it all. Join the club that keeps your home running and your family comfortable. 
            </Typography>

            <Box className="cta-section">
              <Button className="discover-btn" onClick={() => navigate('/membership')}>Get Protected – Join for $125/mo</Button>

              <Box className="play-section">
                {/* <Box className="play-circle">
                  <PlayArrowIcon sx={{ fontSize: 32 }} />
                </Box> */}
              <Button className="discover-btn-services" onClick={() => navigate('/services')}>View Our Services</Button>
{/* 
                <Typography sx={{ textDecoration: "underline", cursor: "pointer" }} onClick={() => navigate('/services')}>
                  View Our Services
                </Typography> */}
              </Box>
            </Box>

            <Box className="rating-box">
              <Box className="avatars">
                {[1, 2, 3, 4].map((i) => (
                  <img key={i} src={`https://i.pravatar.cc/40?img=${i}`} alt="" />
                ))}
              </Box>

              <Box>
                <Typography fontWeight={700}>Average Rating</Typography>
                <Typography sx={{ color: "#7ac142", fontSize: 14 }}>
                  50k+ new review
                </Typography>
              </Box>

              <Box>
                <Typography fontSize={20} fontWeight={700}>4.8</Typography>
                <Box sx={{ display: "flex", mt: 0.5 }}>
                  {Array.from({ length: 5 }).map((_, i) => (
                    <StarIcon key={i} sx={{ fontSize: 20, color: "#FFC400" }} />
                  ))}
                </Box>
              </Box>
            </Box>
          </Box>

          {/* RIGHT */}
          <Box className="hero-right">
            <img
              src="https://html.themehour.net/kleanix/demo/assets/img/hero/hero_3-right_shape.png"
              className="right-green-bg"
              alt=""
            />
            <img
              src="https://html.themehour.net/kleanix/demo/assets/img/hero/hero_3-right_shape2.png"
              className="right-yellow-bg"
              alt=""
            />
            <img
              src={mainImage}
              className="main-man"
              alt="Cleaner"
            />
          </Box>
        </Box>
      </Box>
    </>
  );
};

export default HeroSection;
